export default function Style(){
  return (
    <style>
      {`
       
.fw-400{
    font-weight: 400;
}
.fs-36{
    font-size: 36px !important;
}
.lh-45{
    line-height: 45px;
}
 
@media screen and (max-width: 600px) {
 .responsiveSz {
   font-size: 26px !important;
   line-height: 35px !important;
 }
}

/* // .colorFullSlider .client-logo img{
//      width: 100px !important;
//      height: 100px !important;
// } 
//  .colorFullSlider .slick-list .slick-track {
//      padding: 35px 0 !important;
//  } */

        `}
    </style>
  );
}
 